import { ArrowLeftIcon } from '@heroicons/react/20/solid'
import { ChevronLeftIcon } from '@heroicons/react/24/outline'
import { useCallback } from 'react'

import { useMediaQuery } from '../../hooks/useMediaQuery'
import { Button } from './Button'
import { IconButton } from './IconButton'

interface BackButtonProps {
    onNavigateBack?: () => void
    type?: 'circle' | 'arrow'
    className?: string
}

export const BackButton = ({ onNavigateBack, className = '', type = 'circle' }: BackButtonProps) => {
    const { isMobile } = useMediaQuery()

    const onBack = useCallback(() => {
        if (onNavigateBack) {
            onNavigateBack()
            return
        }
        window.history.back()
    }, [onNavigateBack])

    if (type === 'arrow') {
        return <IconButton className={`${className}`} iconNode={<ArrowLeftIcon className="h-5 w-5 text-gray-400" />} onClick={onBack} />
    }

    return isMobile ? (
        <Button className={`mb-6 ${className}`} intent="text" label="Back" leftIconNode={<ChevronLeftIcon className="h-5 w-5 text-gray-400" />} onClick={onBack} />
    ) : (
        <IconButton className={`mr-6 ${className}`} iconNode={<ChevronLeftIcon className="h-5 w-5 text-gray-400" />} onClick={onBack} />
    )
}
